import React from 'react'

export default function Loader() {
  return (
    <div className="loader_container">
      <div className="relative">
        <div class="track"></div>
        <div class="train"></div>
      </div>
    </div>
  );
}
